import type { SVGProps } from 'react'
const SvgSyArrowUp = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M11.727 3.5a.75.75 0 0 0-.75.75v15a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75"
				opacity={0.4}
			/>
			<path d="M11.725 3.5a.75.75 0 0 0-.532.22L5.17 9.772a.75.75 0 0 0 .002 1.061.75.75 0 0 0 1.06-.004l5.493-5.515 5.494 5.515a.75.75 0 0 0 1.06.004.75.75 0 0 0 .002-1.06L12.256 3.72a.75.75 0 0 0-.531-.221" />
		</g>
	</svg>
)
export default SvgSyArrowUp
